// import { request } from "@/lib/api";
// import { ResponseType } from "@/types/response.types";
// import { useQuery } from "@tanstack/react-query";
// import axios from "axios";
// import React, { useRef, useState, useEffect } from "react";
// import * as S from "./StrokeOrderGeneratorPage.style";
// import { GET_STROKE_LIST } from "@/lib/querykeys";
// import { showToast } from "@/components/atoms/CustomToast";

// const StrokeOrderGeneratorPage = () => {
//   const [currentStrokeNumber, setCurrentStrokeNumber] = useState<number>(1);
//   const [selectedImagePath, setSelectedImagePath] = useState<string>("");
//   const [selectedStrokeData, setSelectedStrokeData] = useState<any>(null);
//   const [selectedId, setSelectedId] = useState<number | null>(null);

//   /** 쓰기 리스트 조회  */
//   const { data: strokeList, refetch: refetchStrokeList } = useQuery(
//     [GET_STROKE_LIST],
//     async () => {
//       const result = await request<ResponseType<any>>({
//         method: "GET",
//         url: `admin/stroke`,
//       });

//       console.log("!! DATA: ", result.data);

//       return result.data;
//     },
//     {
//       onError: (error) => {
//         console.error("Query Error:", error);
//       },
//     }
//   );

//   const handleImageSelect = (e: React.ChangeEvent<HTMLSelectElement>) => {
//     setCurrentStrokeNumber(1);
//     const selectedValue = e.target.value;
//     setSelectedImagePath(selectedValue);

//     // 선택된 이미지의 stroke 데이터와 id 찾기
//     const selectedItem = strokeList?.find(
//       (item: any) => item.files[0]?.path === selectedValue
//     );
//     setSelectedStrokeData(selectedItem?.unit_write_stroke || null);
//     setSelectedId(selectedItem?.id || null);

//     // 셀렉트박스 포커스 해제
//     e.target.blur();
//   };

//   const korean_insert = async () => {
//     const result = await request<ResponseType<any>>({
//       method: "GET",
//       url: `admin/stroke/korean_insert`,
//     });
//   };

//   const math_insert = async () => {
//     const result = await request<ResponseType<any>>({
//       method: "GET",
//       url: `admin/stroke/math_insert`,
//     });
//   };

//   const english_insert = async () => {
//     const result = await request<ResponseType<any>>({
//       method: "GET",
//       url: `admin/stroke/english_insert`,
//     });
//   };

//   return (
//     <S.PageContainer>
//       <FileUpload project="tracing-app" />
//       <S.SelectContainer>
//         <S.Button onClick={() => korean_insert()}>korean_insert</S.Button>
//         <S.Button onClick={() => math_insert()}>math_insert</S.Button>
//         <S.Button onClick={() => english_insert()}>english_insert</S.Button>
//         <S.StyledSelect onChange={handleImageSelect} value={selectedImagePath}>
//           <option value="">이미지를 선택하세요</option>
//           {strokeList?.map((item: any) => (
//             <option key={item.id} value={item.files[0]?.path}>
//               {item.unit_word || item.files[0]?.originalname}
//             </option>
//           ))}
//         </S.StyledSelect>
//       </S.SelectContainer>
//       {selectedImagePath && (
//         <SvgPointSelector
//           imagePath={selectedImagePath}
//           initialStrokes={selectedStrokeData}
//           selectedId={selectedId || undefined}
//           refetchStrokeList={refetchStrokeList}
//           currentStrokeNumber={currentStrokeNumber}
//           setCurrentStrokeNumber={setCurrentStrokeNumber}
//         />
//       )}
//     </S.PageContainer>
//   );
// };

// export default StrokeOrderGeneratorPage;

// interface FileUploadProps {
//   project: string;
// }
// const FileUpload = ({ project }: FileUploadProps) => {
//   const [file, setFile] = useState<any>(null);

//   const handleFileChange = (e: any) => {
//     setFile(e.target.files[0]);
//   };

//   const handleUpload = () => {
//     if (!file) {
//       return alert("Please select a file to upload");
//     }

//     const url = `${process.env.REACT_APP_API_HOST}/upload/${project}`;
//     const formData = new FormData();
//     formData.append("file", file);

//     axios
//       .post(url, formData)
//       .then((response: any) => {
//         console.log("File uploaded successfully");
//       })
//       .catch((error: any) => {
//         console.error("File upload error", error);
//       });
//   };

//   return (
//     <S.UploadContainer>
//       <S.FileInput type="file" onChange={handleFileChange} />
//       <S.Button onClick={handleUpload}>Upload</S.Button>
//     </S.UploadContainer>
//   );
// };

// interface SvgPointSelectorProps {
//   imagePath: string;
//   initialStrokes?: any;
//   selectedId?: number;
//   refetchStrokeList: () => void;
//   currentStrokeNumber: number;
//   setCurrentStrokeNumber: (value: any) => void;
// }

// const SvgPointSelector = ({
//   imagePath,
//   initialStrokes,
//   selectedId,
//   refetchStrokeList,
//   currentStrokeNumber,
//   setCurrentStrokeNumber,
// }: SvgPointSelectorProps) => {
//   const [strokes, setStrokes] = useState<any>(initialStrokes || {});
//   const svgRef = useRef(null);

//   useEffect(() => {
//     setStrokes(initialStrokes || {});
//   }, [initialStrokes]);

//   const handleSvgClick = (event: any) => {
//     const svg = svgRef.current;
//     const point = getSVGCoordinates(event, svg);

//     setStrokes((prevStrokes: any) => {
//       const strokePoints = prevStrokes[currentStrokeNumber] || [];
//       return {
//         ...prevStrokes,
//         [currentStrokeNumber]: [...strokePoints, point],
//       };
//     });
//   };

//   const getSVGCoordinates = (event: any, svg: any) => {
//     const point = svg.createSVGPoint();
//     point.x = event.clientX;
//     point.y = event.clientY;
//     const svgPoint = point.matrixTransform(svg.getScreenCTM().inverse());

//     return {
//       x: svgPoint.x,
//       y: svgPoint.y,
//     };
//   };

//   const handleExport = () => {
//     const dataStr = JSON.stringify(strokes, null, 2);
//     const blob = new Blob([dataStr], { type: "application/json" });
//     const url = URL.createObjectURL(blob);

//     // 파일 다운로드 트리거
//     const link = document.createElement("a");
//     link.href = url;
//     link.download = "strokes.json";
//     link.click();

//     // 리소스 해제
//     URL.revokeObjectURL(url);
//   };

//   const handleReset = () => {
//     setStrokes({});
//   };

//   const handleStrokeNumberChange = (event: any) => {
//     setCurrentStrokeNumber(Number(event.target.value));
//   };

//   useEffect(() => {
//     const handleKeyPress = (event: KeyboardEvent) => {
//       if (event.key === "ArrowUp") {
//         setCurrentStrokeNumber((prev: any) => prev + 1);
//       }
//       if (event.key === "ArrowDown") {
//         setCurrentStrokeNumber((prev: number) => Math.max(1, prev - 1));
//       }
//     };

//     window.addEventListener("keydown", handleKeyPress);
//     return () => window.removeEventListener("keydown", handleKeyPress);
//   }, []);

//   /** DB에 획순 저장 */
//   const handleSaveToDb = async () => {
//     if (!selectedId) {
//       alert("저장할 대상이 선택되지 않았습니다.");
//       return;
//     }

//     try {
//       const response: ResponseType<any> = await request({
//         method: "PUT",
//         url: `admin/stroke/${selectedId}`,
//         data: {
//           unit_write_stroke: strokes,
//         },
//       });

//       console.log("response", response);
//       if (response.success) {
//         refetchStrokeList();
//         showToast("획순이 성공적으로 저장되었습니다.", "success");
//       }
//     } catch (error) {
//       showToast(`획순 저장에 실패했습니다 : ${error}`, "error");
//     }
//   };

//   return (
//     <S.SelectorContainer>
//       <S.Title>SVG 획 포인트 선택기</S.Title>
//       <S.StrokeControlContainer>
//         <S.StrokeButton
//           onClick={() =>
//             currentStrokeNumber > 1 &&
//             setCurrentStrokeNumber((prev: number) => prev - 1)
//           }
//         >
//           -
//         </S.StrokeButton>
//         <S.StrokeNumber>획 번호: {currentStrokeNumber}</S.StrokeNumber>
//         <S.StrokeButton
//           onClick={() => setCurrentStrokeNumber((prev: number) => prev + 1)}
//         >
//           +
//         </S.StrokeButton>
//         <S.StrokeHint>↑↓ 방향키로도 획 번호를 변경할 수 있습니다</S.StrokeHint>
//       </S.StrokeControlContainer>
//       <S.SvgWrapper
//         ref={svgRef}
//         width="500"
//         height="500"
//         viewBox="0 0 1407 1407"
//         onClick={handleSvgClick}
//       >
//         <image
//           href={`${process.env.REACT_APP_IMAGE_URL}/../stroke/math/${imagePath}`}
//           width="100%"
//           height="100%"
//         />
//         {Object.entries(strokes).map(([strokeNumber, points]: any) =>
//           points?.map((point: any, index: number) => (
//             <g key={`${strokeNumber}-${index}`}>
//               {/* 흰색 원형 배경 */}
//               <circle
//                 cx={point.x}
//                 cy={point.y}
//                 r="15"
//                 fill="white"
//                 stroke="black"
//                 strokeWidth="2"
//               />
//               {/* 텍스트 */}
//               <text
//                 x={point.x}
//                 y={point.y}
//                 fontSize="24"
//                 fill="black"
//                 fontWeight="bold"
//                 textAnchor="middle"
//                 dominantBaseline="middle"
//               >
//                 {strokeNumber}
//               </text>
//             </g>
//           ))
//         )}
//       </S.SvgWrapper>
//       <S.ButtonContainer>
//         <S.Button onClick={handleSaveToDb}>획순 저장(DB)</S.Button>
//         <S.Button onClick={handleExport}>획순 파일 다운(json)</S.Button>
//         <S.Button onClick={handleReset}>초기화</S.Button>
//       </S.ButtonContainer>
//       <S.SubTitle>획별 포인트 좌표:</S.SubTitle>
//       <S.CoordinatesDisplay>
//         {JSON.stringify(strokes, null, 2)}
//       </S.CoordinatesDisplay>
//     </S.SelectorContainer>
//   );
// };

import { request } from "@/lib/api";
import { ResponseType } from "@/types/response.types";
import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import React, { useRef, useState, useEffect } from "react";
import * as S from "./StrokeOrderGeneratorPage.style";
import { GET_STROKE_LIST } from "@/lib/querykeys";
import { showToast } from "@/components/atoms/CustomToast";

const StrokeOrderGeneratorPage = () => {
  const [currentStrokeNumber, setCurrentStrokeNumber] = useState<number>(1);
  const [selectedImagePath, setSelectedImagePath] = useState<string>("");
  const [selectedStrokeData, setSelectedStrokeData] = useState<any>(null);
  const [selectedId, setSelectedId] = useState<number | null>(null);
  const [selectedSort, setSelectedSort] = useState<number | null>(null);

  /** 쓰기 리스트 조회 */
  const { data: strokeList, refetch: refetchStrokeList } = useQuery(
    [GET_STROKE_LIST],
    async () => {
      const result = await request<ResponseType<any>>({
        method: "GET",
        url: `admin/stroke`,
      });
      console.log("!! DATA: ", result.data);
      return result.data;
    },
    {
      onError: (error) => console.error("Query Error:", error),
    }
  );

  /** 이미지 선택 (path 기준) */
  const handleImageSelect = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setCurrentStrokeNumber(1);
    const selectedPath = e.target.value;
    if (!selectedPath) return;

    // path로 unit 및 file 탐색
    const unit = strokeList?.find((u: any) =>
      u.files?.some((f: any) => f.path === selectedPath)
    );
    const file = unit?.files?.find((f: any) => f.path === selectedPath);

    if (!unit || !file) {
      console.error("선택한 path에 해당하는 unit/file을 찾을 수 없습니다.");
      return;
    }

    setSelectedId(unit.id);
    setSelectedSort(Number(file.sort));
    setSelectedImagePath(selectedPath);

    // 전체 unit_write_stroke 맵 유지
    const allStrokesMap = unit.unit_write_stroke || {};
    setSelectedStrokeData(allStrokesMap);

    e.target.blur();
  };

  /** 더미 API */
  const korean_insert = async () =>
    await request<ResponseType<any>>({
      method: "GET",
      url: `admin/stroke/korean_insert`,
    });
  const math_insert = async () =>
    await request<ResponseType<any>>({
      method: "GET",
      url: `admin/stroke/math_insert`,
    });
  const english_insert = async () =>
    await request<ResponseType<any>>({
      method: "GET",
      url: `admin/stroke/english_insert`,
    });

  return (
    <S.PageContainer>
      <FileUpload project="tracing-app" />
      <S.SelectContainer>
        <S.Button onClick={() => korean_insert()}>korean_insert</S.Button>
        <S.Button onClick={() => math_insert()}>math_insert</S.Button>
        <S.Button onClick={() => english_insert()}>english_insert</S.Button>

        <S.StyledSelect onChange={handleImageSelect} value={selectedImagePath}>
          <option value="">이미지를 선택하세요</option>
          {strokeList?.flatMap((unit: any) =>
            unit.files.map((file: any) => (
              <option key={file.id} value={file.path}>
                {`${unit.unit_word || file.originalname} (sort: ${file.sort})`}
              </option>
            ))
          )}
        </S.StyledSelect>
      </S.SelectContainer>

      {selectedImagePath && (
        <SvgPointSelector
          imagePath={selectedImagePath}
          initialStrokesAll={selectedStrokeData}
          selectedId={selectedId || undefined}
          selectedSort={selectedSort || 0}
          refetchStrokeList={refetchStrokeList}
          currentStrokeNumber={currentStrokeNumber}
          setCurrentStrokeNumber={setCurrentStrokeNumber}
        />
      )}
    </S.PageContainer>
  );
};

export default StrokeOrderGeneratorPage;

/* ------------------------------ 파일 업로드 ------------------------------ */

interface FileUploadProps {
  project: string;
}
const FileUpload = ({ project }: FileUploadProps) => {
  const [file, setFile] = useState<any>(null);

  const handleFileChange = (e: any) => setFile(e.target.files[0]);

  const handleUpload = () => {
    if (!file) {
      return alert("Please select a file to upload");
    }

    const url = `${process.env.REACT_APP_API_HOST}/upload/${project}`;
    const formData = new FormData();
    formData.append("file", file);

    axios
      .post(url, formData)
      .then(() => console.log("File uploaded successfully"))
      .catch((error: any) => console.error("File upload error", error));
  };

  return (
    <S.UploadContainer>
      <S.FileInput type="file" onChange={handleFileChange} />
      <S.Button onClick={handleUpload}>Upload</S.Button>
    </S.UploadContainer>
  );
};

/* ------------------------------ SVG 포인트 선택 ------------------------------ */

interface SvgPointSelectorProps {
  imagePath: string;
  initialStrokesAll?: any;
  selectedId?: number;
  selectedSort: number;
  refetchStrokeList: () => void;
  currentStrokeNumber: number;
  setCurrentStrokeNumber: (value: any) => void;
}

const SvgPointSelector = ({
  imagePath,
  initialStrokesAll,
  selectedId,
  selectedSort,
  refetchStrokeList,
  currentStrokeNumber,
  setCurrentStrokeNumber,
}: SvgPointSelectorProps) => {
  const [strokes, setStrokes] = useState<any>(initialStrokesAll || {});
  const svgRef = useRef<SVGSVGElement | null>(null);

  useEffect(() => {
    setStrokes(initialStrokesAll || {});
  }, [initialStrokesAll]);

  /** SVG 클릭 → 좌표 추가 */
  const handleSvgClick = (event: any) => {
    const svg = svgRef.current;
    if (!svg) return;

    const point = svg.createSVGPoint();
    point.x = event.clientX;
    point.y = event.clientY;
    const svgPoint = point.matrixTransform(svg.getScreenCTM()!.inverse());
    const newPoint = { x: svgPoint.x, y: svgPoint.y };

    setStrokes((prev: any) => {
      const sortKey = String(selectedSort);
      const currentSortData = prev[sortKey] || {};
      const currentStrokePoints = currentSortData[currentStrokeNumber] || [];
      return {
        ...prev,
        [sortKey]: {
          ...currentSortData,
          [currentStrokeNumber]: [...currentStrokePoints, newPoint],
        },
      };
    });
  };

  /** DB 저장 (전체 맵 유지) */
  const handleSaveToDb = async () => {
    if (!selectedId) {
      alert("저장할 대상이 선택되지 않았습니다.");
      return;
    }

    try {
      const response: ResponseType<any> = await request({
        method: "PUT",
        url: `admin/stroke/${selectedId}`,
        data: {
          unit_write_stroke: strokes,
        },
      });

      if (response.success) {
        refetchStrokeList();
        showToast("획순이 성공적으로 저장되었습니다.", "success");
      }
    } catch (error) {
      showToast(`획순 저장에 실패했습니다 : ${error}`, "error");
    }
  };

  /** JSON 파일 다운로드 */
  const handleExport = () => {
    const dataStr = JSON.stringify(strokes, null, 2);
    const blob = new Blob([dataStr], { type: "application/json" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = "strokes.json";
    link.click();
    URL.revokeObjectURL(url);
  };

  const handleReset = () => setStrokes({});

  /** ↑↓ 키로 획 변경 */
  useEffect(() => {
    const handleKeyPress = (event: KeyboardEvent) => {
      if (event.key === "ArrowUp") {
        setCurrentStrokeNumber((prev: number) => prev + 1);
      }
      if (event.key === "ArrowDown") {
        setCurrentStrokeNumber((prev: number) => Math.max(1, prev - 1));
      }
    };
    window.addEventListener("keydown", handleKeyPress);
    return () => window.removeEventListener("keydown", handleKeyPress);
  }, []);

  /** 현재 sort의 데이터만 표시 */
  const currentSortData = strokes?.[String(selectedSort)] || {};

  return (
    <S.SelectorContainer>
      <S.Title>SVG 획 포인트 선택기</S.Title>

      <S.StrokeControlContainer>
        <S.StrokeButton
          onClick={() =>
            currentStrokeNumber > 1 &&
            setCurrentStrokeNumber((prev: number) => prev - 1)
          }
        >
          -
        </S.StrokeButton>
        <S.StrokeNumber>획 번호: {currentStrokeNumber}</S.StrokeNumber>
        <S.StrokeButton
          onClick={() => setCurrentStrokeNumber((prev: number) => prev + 1)}
        >
          +
        </S.StrokeButton>
        <S.StrokeHint>↑↓ 방향키로 획 번호 변경 가능</S.StrokeHint>
      </S.StrokeControlContainer>

      <S.SvgWrapper
        ref={svgRef}
        width="500"
        height="500"
        viewBox="0 0 1407 1407"
        onClick={handleSvgClick}
      >
        <image
          href={`${process.env.REACT_APP_IMAGE_URL}/../stroke/english/${imagePath}`}
          width="100%"
          height="100%"
        />
        {Object.entries(currentSortData).flatMap(([strokeNum, points]: any) =>
          points?.map((pt: any, idx: number) => (
            <g key={`${selectedSort}-${strokeNum}-${idx}`}>
              <circle
                cx={pt.x}
                cy={pt.y}
                r="15"
                fill="white"
                stroke="black"
                strokeWidth="2"
              />
              <text
                x={pt.x}
                y={pt.y}
                fontSize="24"
                fill="black"
                fontWeight="bold"
                textAnchor="middle"
                dominantBaseline="middle"
              >
                {strokeNum}
              </text>
            </g>
          ))
        )}
      </S.SvgWrapper>

      <S.ButtonContainer>
        <S.Button onClick={handleSaveToDb}>획순 저장(DB)</S.Button>
        <S.Button onClick={handleExport}>획순 파일 다운(json)</S.Button>
        <S.Button onClick={handleReset}>초기화</S.Button>
      </S.ButtonContainer>

      <S.SubTitle>획별 포인트 좌표(JSON):</S.SubTitle>
      <S.CoordinatesDisplay>
        {JSON.stringify(strokes, null, 2)}
      </S.CoordinatesDisplay>
    </S.SelectorContainer>
  );
};
